// src/components/common/table/sx.ts

import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

/**
 * A single `sx` item (NOT MUI's `SxProps`) to avoid nested array typing issues.
 * We intentionally keep the shape simple:
 * - style object
 * - or a theme callback returning a style object
 */
export type SxItem =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

/**
 * Merge sx items into a flat array while filtering falsy values.
 * This is useful for projects where `sx={[...maybeUndefined]}` causes TS issues.
 */
export const sx = (
  ...items: Array<SxItem | null | undefined | false>
): readonly SxItem[] => items.filter(Boolean) as SxItem[];
